import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { enableMapSet } from 'immer'
import routes from './routes.js'

// Allow Map() and Set() in jotai-immer
enableMapSet()

const Router = BrowserRouter

const root = ReactDOM.createRoot(document.getElementById('root'))
// https://reactrouter.com/en/main/routers/create-browser-router

root.render(
  <React.StrictMode>
    <Router>
      <Routes>{
        routes.map(({ path, component: Component }) => {
          return <Route key={path} path={path} element={<Component />} />
        })
      }</Routes>
    </Router>
  </React.StrictMode>
)
